<template>
  <div>
    <div class="main">
      <img class="check-img" src="@/assets/fail-ic.png" />
      <p class="text-line1">로그인 실패</p>
      <p class="text-line2">잠시 후 다시 로그인해 주세요</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActiveVue: true,
    };
  },
  created() {
    const self = this;

    let timer = setTimeout(() => {
      clearTimeout(timer);
      timer = null;
      self.$router.replace({
        name: "login",
        params: {
          t: new Date().getTime(),
        },
      });
    }, 2000);
  },
  activated() {
    this.isActiveVue = true;
  },
  deactivated() {
    this.isActiveVue = false;
  },
};
</script>

<style scoped>
.main {
  margin-top: 388.5px;
  text-align: center;
}
.check-img {
  width: 128px;
  height: 129px;
}
.text-line1 {
  font-size: 56px;
  line-height: 1;
  color: #eeeeee;
  margin: 40px 0;
}
.text-line2 {
  font-size: 28px;
  line-height: 1.29;
  color: #888888;
}

@media all and (min-width:0px) and (max-width:1280px){
  .main {
    margin-top: 0px;
    top: 50%;
    transform: translateY(-50%);
    text-align: center;
  }
  .check-img {
    width: 64px;
    height: 64px;
  }
  .text-line1 {
    font-size: 32px;
    line-height: 1;
    color: #ffffff;
    margin: 40px 0 24px;
    font-weight: bold;
  }
  .text-line2 {
    font-size: 20px;
    line-height: 1;
    color: #888888;
  }
}
</style>